export const UPDATE_CONVERSATION_FOOTER_HEIGHT =
  'UPDATE_CONVERSATION_FOOTER_HEIGHT'
export const UPDATE_HEADER_HEIGHT = 'UPDATE_HEADER_HEIGHT'
export const SET_OVERLAY_OPEN = 'SET_OVERLAY_OPEN'
export const SET_PARENT_SIZE = 'SET_PARENT_SIZE'
